import './src/assets/scss/main.scss';
import 'rc-pagination/assets/index.css';
import React from 'react';
import AuthProvider from './src/contexts/AuthContext';
import DataProvider from './src/contexts/DataContext';

export const wrapRootElement = ({ element }) => (
  <AuthProvider>
    <DataProvider>{element}</DataProvider>
  </AuthProvider>
);
